import React from "react";
import { useSelector } from "react-redux";
import AccountsPage from "../../components/dashboard/AccountsPage";
import {
  createOperator,
  deleteOperatorAccount,
  getOperators,
  updateOperatorAccount,
} from "../../redux/actions/userActions";

const ROLES = [
  { value: "operator", label: "Opérateur" },
  { value: "admin", label: "Administrateur" },
];

function Operators() {
  const { operators } = useSelector((state) => state.users);

  return (
    <AccountsPage
      title="Opérateurs"
      lead="Les membres de l'équipe qui traitent les démarches."
      accounts={operators}
      load={getOperators}
      create={createOperator}
      update={updateOperatorAccount}
      remove={deleteOperatorAccount}
      roles={ROLES}
      emptyText="Aucun opérateur pour le moment."
    />
  );
}

export default Operators;
